// Import chart.js
import Chart from "chart.js/auto";
import annotationPlugin from "chartjs-plugin-annotation";

Chart.register(annotationPlugin);

// Set to true to enable console output
let ficalcDebug = false;




// early variables
let ageInput = document.getElementById("age");
let debtInput = document.getElementById("debt");
let incomeInput = document.getElementById("income")
let portfolioInput = document.getElementById("portfolio")
let contributionsInput = document.getElementById("contributions")
let spendingInput = document.getElementById("spending")

// late variables
let graphResults = [];
let myAge = 0;
let myDebt = 0;
let myIncome = 0;
let myPortfolio = 0;
let myContribution = 0;
let mySpending = 0;
let marketReturns = 1.13;
let contributionRate = 0;
let netWorth = 0;
let requiredPortfolio = 0;
let cumulativeContribution = 0;
let cumulativeReturns = 0;
let graphAgeLabels = [];
let graphDataContributions = [];
let graphDataReturns = [];

let retirementAge = myAge;
let originalAge = myAge;

// Post results modifiers
let contribution5 = document.getElementById("contribution5");
let contribution10 = document.getElementById("contribution10");
let contribution15 = document.getElementById("contribution15");
var returnsModifier = document.getElementById('returnsModifier');


var financialChart;

// Configuration objects for the chart
// Doing it this way makes it easier to update the data
var contributionsObj = {
    label: "Contributions",
    data: [],
    backgroundColor: 'rgba(51, 161, 253, 0.9)',
    borderColor: 'rgba(51, 161, 253, 0.9)',
    borderWidth: 1,
    fill: {
        target: "origin",
    },
}

var returnsObj = {
    label: "Market Returns",
    data: [],
    backgroundColor: 'rgba(31, 212, 198, 0.9)',
    borderColor: 'rgba(31, 212, 198, 0.9)',
    borderWidth: 1,
    fill: {
        target: 0,
    },
}


function createChart() {
    let ctx = document.getElementById("Chart");

    contributionsObj.data = graphDataContributions;
    returnsObj.data = graphDataReturns;

    financialChart = new Chart(ctx, {
        type: "line",
        data: {
            labels: graphAgeLabels,
            datasets: [
                contributionsObj,
                returnsObj,
            ],
        },
        options: {
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    beginAtZero: true,
                    ticks: {
                        autoSkip: true,
                        maxTicksLimit: 8,
                    },
                    title: {
                        text: "Age",
                        display: true,
                    },
                },
                y: {
                    beginAtZero: false,
                    title: {
                        text: "Retirement Savings",
                        display: true,
                    },
                    ticks: {
                        autoSkip: true,
                        maxTicksLimit: 5,
                        callback: function (value, index, values) {
                            return "$" + value;
                        },
                    },
                },
            },
            plugins: {
                legend: {
                    labels: {
                        boxHeight: 20,
                        boxWidth: 20,
                    },
                },
                annotation: {
                    annotations: {
                        line1: {
                            type: 'line',
                            xMin: null,
                            xMax: null,
                            borderColor: 'rgba(0,0,0,1)',
                            borderDash: [10, 12],
                            borderWidth: 2,
                            label: {
                                content: "",
                                enabled: true,
                                yAdjust: -65,
                            },
                        },
                    },
                },
            },
        },
    });

}


// get the values from the input fields
// Calculate derived variables from the input fields
function resetVariables() {
    graphResults = [];
    myAge = parseInt(ageInput.value);
    myDebt = parseInt(debtInput.value);
    myIncome = parseInt(incomeInput.value);
    myPortfolio = parseInt(portfolioInput.value);
    myContribution = parseInt(contributionsInput.value);
    mySpending = parseInt(spendingInput.value);
    marketReturns = 1.13;
    contributionRate = myContribution / myIncome;
    netWorth = myPortfolio - myDebt;
    requiredPortfolio = mySpending * 25;
    cumulativeContribution = myContribution;
    cumulativeReturns = myPortfolio - cumulativeContribution;
    graphAgeLabels = [];
    graphDataContributions = [];
    graphDataReturns = [];

    retirementAge = myAge;
    originalAge = myAge;
}


function calcOutput() {
    let i = 0;

    // Create array for results
    graphResults = [
        {
            age: myAge,
            annualIncome: myIncome,
            annualRetirementContributions: myContribution,
            cumulativeRetirementContributions: cumulativeContribution,
            currentDebts: myDebt,
            currentPortfolio: myPortfolio,
            expectedAnnualRetirementExpenses: mySpending,
            netWorth: netWorth,
            requiredPortfolio: requiredPortfolio,
            cumulativeReturns: cumulativeReturns,
        },
    ];

    // Main calculation loop
    do {
        i++;
        do {
            retirementAge++;
            myAge++;
            myIncome = Math.round(myIncome * 1.04);
            myPortfolio = Math.round((myPortfolio + myContribution) * marketReturns);
            myContribution = Math.round(myIncome * contributionRate);
            cumulativeContribution = cumulativeContribution + myContribution;
            cumulativeReturns = myPortfolio - cumulativeContribution;
            mySpending = Math.round(mySpending * 1.03);
            requiredPortfolio = mySpending * 25;
            netWorth = myPortfolio - myDebt;

            // Push results to array on each iteration
            graphResults.push({
                age: myAge,
                annualIncome: myIncome,
                annualRetirementContributions: myContribution,
                cumulativeRetirementContributions: cumulativeContribution,
                currentDebts: myDebt,
                currentPortfolio: myPortfolio,
                expectedAnnualRetirementExpenses: mySpending,
                netWorth: netWorth,
                requiredPortfolio: requiredPortfolio,
                cumulativeReturns: cumulativeReturns,
            });
        } while (netWorth < requiredPortfolio);
    } while (i < 10);

    ficalcDebug ? console.table(graphResults) : null;

    // Output ages to array to be used as graph x-axis
    graphAgeLabels = graphResults.map((a) => a.age);

    // Output cumulative contributions to array for dataset 1
    graphDataContributions = graphResults.map(
        (a) => a.cumulativeRetirementContributions
    );

    // Output cumulative returns to array for dataset 2
    graphDataReturns = graphResults.map((a) => a.cumulativeReturns);

    ficalcDebug ? console.log(graphAgeLabels) : null;
    ficalcDebug ? console.log(graphDataContributions) : null;
    ficalcDebug ? console.log(graphDataReturns) : null;
} 



// Update Age and Returns data for the chart
// Do this instead of destroying the chart and re-creating it.
function chartUpdate() {
    // overwrite the current labels
    financialChart.data.labels = graphAgeLabels;

    // pop (remove) the existing data
    financialChart.data.datasets.pop();
    financialChart.data.datasets.pop();

    // put the new data into the config objects
    contributionsObj.data = graphDataContributions;
    returnsObj.data = graphDataReturns;

    // push the new data
    financialChart.data.datasets.push(contributionsObj);
    financialChart.data.datasets.push(returnsObj);

    financialChart.update();
}




calcButton.addEventListener("click", function (e) {
    // Since we aren't submitting the form to a server, we need to make sure the native
    // browser validation happens for all required fields
    if (!ageInput.validity.valid || !debtInput.validity.valid || !incomeInput.validity.valid ||
        !portfolioInput.validity.valid || !contributionsInput.validity.valid || !spendingInput.validity.valid) {
        return;
    }

    // don't perform a submit action
    e.preventDefault();

    resetVariables();

    // reset this in case the user adjusted before this run
    returnsModifier.value = 10;

    if ( ! isContributionRateValid() ) {
        return;
    }

    // run the calculation based on the user inputs
    calcOutput();

    // first time through, we have to create the chart object
    if ( typeof financialChart == 'undefined' ) {
        createChart();
    } else {
        chartUpdate();
    }

    // Update the output text fields and chart annotation
    updateText();

    // show the results panel
    document.getElementById("resultsContainer").classList.add("calc-results--show");


    // scroll down to the outputs if necessary
    jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery("#resultsContainer").offset().top
    }, 500);

});

function isContributionRateValid() {
    // error checking for contribution > income
    if ( myContribution > myIncome ) {
        ficalcDebug ? console.log('contribution over 100%') : null;
        document.getElementById('contribRateError').classList.add('show');
        return false;
    } else {
        return true;
    }
}


function updateText() {
    let displayAge = retirementAge - 9;
    let displayYears = displayAge - originalAge;

    document.getElementById("retirementAge").innerHTML = displayAge;
    document.getElementById("retirementYears").innerHTML = displayYears;

    updateAnnotation(displayAge, displayYears);

    // Current Contribution Rate
    document.getElementById("currentContributionRate").innerHTML = Math.round(contributionRate * 100) + "%";

    // Possible Market Returns
    document.getElementById("possibleMarketReturns").innerHTML = Math.round((marketReturns - 1) * 100) - 3 + "%";
}



function updateAnnotation(displayAge, displayYears) {
    ficalcDebug ? console.log("Retire in " + displayYears + " years at age " + displayAge) : null;

    // the annotation line is placed at an index on the X axis, not the value at that index
    let indexAge = graphAgeLabels.indexOf(displayAge);

    financialChart.options.plugins.annotation.annotations.line1.xMin = indexAge;
    financialChart.options.plugins.annotation.annotations.line1.xMax = indexAge;

    financialChart.options.plugins.annotation.annotations.line1.label.content = "Retire in " + displayYears + " years at age " + displayAge;

    // lock in the new annotation data
    financialChart.update();
}


// Each of +5, +10, and +15 follow the same formula
function addPercentage(percentToAdd) {

    // turn off any active modifier buttons
    let activeButtons = document.querySelectorAll('.calc-results__contribution-button__single.active');
    activeButtons.forEach( el => el.classList.remove('active'));

    resetVariables();

    // do some error checking to make sure the user hasn't tried to contribute more than 100%
    let diff = 1 - percentToAdd;

    if (contributionRate < diff) {

        contributionRate += percentToAdd;

        // Need to account for market return modifier
        marketReturns = 1 + (parseInt(returnsModifier.value) + 3) / 100;

        // run the calculation and update the text and chart
        calcOutput();
        chartUpdate();
        updateText();
        return true;

    } else {
        document.getElementById('modifierRateError').classList.add('show');
        return false;
    }
}




// 
// Contribution rate modifier buttons
// 
contribution5.addEventListener("click", function () {
    // are we removing this scenario?
    if ( this.classList.contains('active') ) {
        revert();
    } else {
        let outcome = addPercentage(0.05);
        if (outcome) {
            this.classList.add('active');
        }
    }

});

contribution10.addEventListener("click", function () {
    // are we removing this scenario?
    if ( this.classList.contains('active') ) {
        revert();
    } else {
        let outcome = addPercentage(0.1);
        if (outcome) {
            this.classList.add('active');
        }
    }
});

contribution15.addEventListener("click", function () {
    // are we removing this scenario?
    if ( this.classList.contains('active') ) {
        revert();
    } else {
        let outcome = addPercentage(0.15);
        if (outcome) {
            this.classList.add('active');
        }
    }
});
// 
// End Contribution rate modifier buttons
// 



// Revert the contribution rate modifier
function revert() {
    // turn off any active modifier buttons
    let activeButtons = document.querySelectorAll('.calc-results__contribution-button__single.active');
    activeButtons.forEach( el => el.classList.remove('active'));

    resetVariables();

    // Need to account for market return modifier
    marketReturns = 1 + (parseInt(returnsModifier.value) + 3) / 100;

    calcOutput();
    chartUpdate();
    updateText();
}


// Test the effect of different market returns
returnsModifier.addEventListener( 'change', function(e) {
    resetVariables();

    // check for contribution rate error
    // This may be possible if the user has adjusted inputs
    // after the initial chart render, but has dismissed
    // the error popup in the form section.
    if ( myContribution > myIncome ) {
        document.getElementById('modifierRateError').classList.add('show');
        return;
    }

    let activeButtons = document.querySelectorAll('.calc-results__contribution-button__single.active');

    ficalcDebug ? console.log(activeButtons) : null;

    // account for contribution modifier
    if ( activeButtons.length > 0 ) {
        switch (activeButtons[0].id) {
            case 'contribution5':
                contributionRate += 0.05;
                break;
        
            case 'contribution10':
                contributionRate += 0.10;
                break;
        
            case 'contribution15':
                contributionRate += 0.15;
                break;
        
            default:
                break;
        }
    }

    // Adjust the market return for this run
    // Add 3 to account for inflation in the calculations
    marketReturns = 1 + (parseInt(this.value) + 3) / 100;
    ficalcDebug ? console.log(marketReturns) : null;

    calcOutput();
    chartUpdate();
    updateText();
});


// Reset in this case means 'allow the user to adjust their inputs'
// Don't actually remove the values in the input fields or 
// hide the output.
reset.addEventListener("click", function () {
    // turn off any active modifier buttons
    let activeButtons = document.querySelectorAll('.calc-results__contribution-button__single.active');
    activeButtons.forEach( el => el.classList.remove('active'));

    document.getElementById("age").value = "";
    document.getElementById("debt").value = "";
    document.getElementById("income").value = "";
    document.getElementById("portfolio").value = "";
    document.getElementById("contributions").value = "";
    document.getElementById("spending").value = "";
  
    document.getElementById('resultsContainer').classList.remove('calc-results--show');


    jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery("#fi-calc").offset().top
    }, 500);

});



let crError = document.getElementById('contribRateError');

crError.addEventListener( 'click', function(e) {

    // since this is a button inside the form, we must preventDefault
    // to keep it from reloading the page when clicked.
    e.preventDefault();

    // is error popup shown?
    if ( this.classList.contains('show')) {
        this.classList.remove('show');
    }

});

let mrError = document.getElementById('modifierRateError');

mrError.addEventListener( 'click', function(e) {

    // is error popup shown?
    if ( this.classList.contains('show')) {
        this.classList.remove('show');
    }

});

